// What the secondary row (SecondaryFilters, shown from sm) already offers per width. A filter the
// row shows at a width is left out of the drawer there.
const ROW_BREAKPOINTS = ['sm', 'md']

// Each row checkbox and the first breakpoint it shows from. Multiple parts is hidden at 640-959
// (PrintAttributes `isHiddenAtSm`). Game-ready and Has renders have no row checkbox.
const ROW_FEATURE_FROM = {
  animated: 'sm',
  rigged: 'sm',
  low_poly: 'sm',
  pbr: 'sm',
  with_makes: 'sm',
  three_d_print_verified: 'sm',
  pre_supported: 'sm',
  multiple_parts: 'md',
}

export const isRowVisible = breakpoint => ROW_BREAKPOINTS.includes(breakpoint)

// Style and Poly count leave the row at sm, where only the checkboxes fit (.secondary-filters__dropdown).
export const rowShowsDropdowns = breakpoint => breakpoint === 'md'

export const featuresOutsideRow = (features, breakpoint) => {
  if (!isRowVisible(breakpoint)) return features

  return features.filter(({ value }) => {
    const from = ROW_FEATURE_FROM[value]
    return !from || ROW_BREAKPOINTS.indexOf(breakpoint) < ROW_BREAKPOINTS.indexOf(from)
  })
}
